import react from 'react';
const Footer = () => {
    return (
        <footer className="card-footer">
      <p className="small-text">
        <a href="https://connect4u.co.il/?page_id=774" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> 
        | 
        <a href="https://connect4u.co.il/?page_id=789" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </p>
    </footer>
    );
};

export default Footer;